import { supabase } from "../../supabaseClient";

export async function createBug(formData, currentUser = null) {

    const bugToInsert = {

    ...formData,

    platform_id: Number(formData.platform_id),

    bug_status_id: 1,          // New

    source_id: 1,              // Internal Testing

    reported_by: currentUser?.id ?? null,

    environment: process.env.NODE_ENV,

    version: process.env.REACT_APP_VERSION || "development"

};

    const { data, error } = await supabase
        .from("bug_reports")
        .insert([bugToInsert])
        .select()
        .single();

    if (error) throw error;

    return data;

}